import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addPaymentEntry = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    // '/api/method/technoerp.services.create_payment_entry',
    '/api/resource/Payment Entry',
    body
  );
  return data;
});
export const updatePaymentEntry = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    // '/api/method/technoerp.services.update_payment_entry',
    `/api/resource/Payment Entry/${id}`,
    body
  );
  return data;
});
export const getPaymentEntries = catchAsync(async ({ key, value }) => {
  let baseUrl =
    '/api/resource/Payment Entry?fields=["name", "payment_type", "posting_date", "mode_of_payment", "party_type", "party", "party_name", "paid_amount","total_allocated_amount", "status","docstatus"]&limit_start=0&limit_page_length=0&order_by=name desc';
  if (value) {
    if (key === 'posting_date') {
      baseUrl += `&filters=[["posting_date","Between",["${key}","${value}"]]]`;
    } else {
      baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
    }
  }
  const { data } = await axiosInstance.get(baseUrl);
  return data;
});
export const getPaymentVoucher = catchAsync(async ({ key, value }) => {
  let baseUrl =
    '/api/resource/Payment Entry?fields=["name", "payment_type", "posting_date", "mode_of_payment", "party_type", "party", "party_name", "paid_amount","total_allocated_amount", "status","docstatus"]&limit_start=0&limit_page_length=0&order_by=name desc';
  if (value) {
    if (key === 'posting_date') {
      baseUrl += `&filters=[["payment_type":"pay"],["posting_date","Between",["${key}","${value}"]]]`;
    } else {
      baseUrl += `&filters=[["payment_type":"pay"],["${key}","like","%${value}%"]]`;
    }
  } else {
    baseUrl += `&filters={"payment_type":"pay"}`;
  }
  const { data } = await axiosInstance.get(
    baseUrl
    // '/api/method/technoerp.services.get_payment_entries'
  );
  return data;
});
export const getPaymentReceiptVoucher = catchAsync(async ({ key, value }) => {
  let baseUrl =
    '/api/resource/Payment Entry?fields=["name", "payment_type", "posting_date", "mode_of_payment", "party_type", "party", "party_name", "paid_amount","total_allocated_amount", "status","docstatus"]&limit_start=0&limit_page_length=0&order_by=name desc';
  if (value) {
    if (key === 'posting_date') {
      // baseUrl += `&filters=[["payment_type","pay"],["posting_date","Between",["${key}","${value}"]]]`;
      baseUrl += `&filters=[["payment_type":"Receive"],["posting_date","Between",["${key}","${value}"]]]`;
    } else {
      baseUrl += `&filters=[["payment_type":"Receive"],["${key}","like","%${value}%"]]`;
    }
  } else {
    baseUrl += `&filters={"payment_type":"Receive"}`;
  }
  const { data } = await axiosInstance.get(
    baseUrl
    // '/api/method/technoerp.services.get_payment_entries'
  );
  return data;
});
export const getModeOfPayments = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_mode_of_payments'
  );
  return data;
});
export const getAccounts = catchAsync(async (filter = '{"is_group":0}') => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_accounts?filters=' + filter,
    {
      params: {
        limit_page_length: 0,
      },
    }
  );
  return data;
});
export const getParties = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_parties?partyType=${id}`
  );
  return data;
});
export const getPaymentEntryDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    // `/api/method/technoerp.services.get_payment_entry?name=${id}`
    `/api/resource/Payment Entry/${id}`
  );
  return data;
});
export const getPaymentReferences = catchAsync(async (party, id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_payment_references?referenceDoctype=${id}&party=${party}`
  );
  return data;
});
export const getPaymentEntryDetailsName = catchAsync(async (type, id) => {
  const { data } = await axiosInstance.get(
    // `/api/method/technoerp.services.get_journal_entry?name=${id}`
    `/api/method/technoerp.services.get_PE_details?type=${type}&name=${id}`
  );
  return data;
});
export const getSalesInvoiceDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_payment_entry?entry=${id}`
  );
  return data;
});

export const deleteSalesInvoice = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/method/technoerp.services.delete_record?record=${record}&document=Payment Entry`
  );
  return data;
});

export const getCustomerSalesInvoices = catchAsync(async (customerName) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_customer_sales_invoices?customer=${customerName}`
  );
  return data;
});

export const submitDoc = catchAsync(async (name) => {
  const { data } = await axiosInstance.post(
    `/api/method/technoerp.services.submit_doc?type=Payment Entry&name=${name}`
  );
  return data;
});

export const cancelPaymentEntry = catchAsync(async (record) => {
  const { data } = await axiosInstance.post(
    `/api/method/technoerp.services.cancel_record?record=${record}&document=Payment Entry`
  );
  return data;
});
export const getMopAccountMode = catchAsync(async (id) => {
  const { data } = await axiosInstance.post(
    `/api/method/technoerp.services.get_mop_account?mode=${id}`
  );
  return data;
});
